import { render, staticRenderFns } from "./PetrolCategories.vue?vue&type=template&id=4820904e&"
import script from "./PetrolCategories.vue?vue&type=script&lang=js&"
export * from "./PetrolCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports